export enum EStatusConjunto {
  AGUARDANDO = 'AGUARDANDO',
  LIBERADO = 'LIBERADO',
  REPROVADO = 'REPROVADO',
}
